module.exports = __webpack_public_path__ + "img/coin.1de614e9.svg";